var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      attrs: {
        column: "",
        role: "region",
        "aria-label": "Terms and conditions content",
      },
    },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/tclayout-cover.png",
          height: "350",
          role: "img",
          "aria-label": "Terms and Conditions Banner",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        {
          attrs: {
            flat: "",
            role: "region",
            "aria-label": "Terms and Conditions Content",
          },
        },
        [
          _c(
            "v-layout",
            {
              class: {
                "column pb-2": _vm.$vuetify.breakpoint.mdAndDown,
                "row pb-2": _vm.$vuetify.breakpoint.lgAndUp,
              },
              attrs: { role: "presentation" },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "offset-lg2": "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "profile-section-card--flex-toolbar",
                      attrs: {
                        flat: "",
                        role: "group",
                        "aria-label": "Terms and Conditions Sections",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-md": "" } },
                            [
                              _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    "fixed-tabs": "",
                                    color: "accent",
                                    "show-arrows": "",
                                    centered: "",
                                    "next-icon": "fad fa-chevron-right",
                                    "prev-icon": "fad fa-chevron-left",
                                    "slider-color": "accent",
                                    role: "tablist",
                                    "aria-label":
                                      "Terms and Conditions Navigation Tabs",
                                  },
                                },
                                [
                                  _c("v-tabs-slider"),
                                  _vm._v(" "),
                                  _vm._l(_vm.tabs, function (tab) {
                                    return _c(
                                      "v-tab",
                                      {
                                        key: tab.id,
                                        attrs: {
                                          to: tab.route,
                                          exact: "",
                                          role: "tab",
                                          "aria-selected":
                                            _vm.$route.path === tab.route,
                                          tabindex:
                                            _vm.$route.path === tab.route
                                              ? 0
                                              : -1,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-1",
                                            attrs: { "aria-hidden": true },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(tab.icon) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("tc.tabs." + tab.id) ||
                                                tab.id
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("router-view", {
                                attrs: {
                                  role: "region",
                                  "aria-live": "polite",
                                  "aria-label":
                                    "Terms and Conditions Content Section",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }